// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"ExpertWidgetsConfigPanel_sectionTitle__1gZ-D","addWidget":"ExpertWidgetsConfigPanel_addWidget__2qjHG"};